import React from "react";
import "../../assets/css/videoModal.css";

function VideoModal({ video, onClose }) {

    if (!video) return null;

    return (

        <div
            className="image-modal-overlay"
            onClick={onClose}
        >

            <div
                className="image-modal-container"
                onClick={(e) => e.stopPropagation()}
            >

                {/* Close Button */}
                <button
                    type="button"
                    className="modal-close"
                    onClick={onClose}
                    aria-label="Close Video"
                >
                    ✕
                </button>

                <div className="modal-image-wrapper">

                    <video
                        className="modal-video"
                        controls
                        autoPlay
                    >
                        <source
                            src={video.videoUrl}
                            type="video/mp4"
                        />

                        Your browser does not support the video tag.

                    </video>

                </div>

                <div className="modal-info">

                    <h2>{video.title}</h2>

                    <p>{video.category}</p>

                </div>

            </div>

        </div>

    );

}

export default VideoModal;